import { Alert, Box, Container, Typography } from "@mui/material"
import Page from "minimals-template/components/Page"
import { splitId } from "library/database/split-id.mjs"
import { UpBar } from "routes/schedule/components/up-bar"
import useSettings from "minimals-template/components/@hooks/useSettings"
import { CompareTwo } from "routes/schedule/compare/compareTwo"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { getTopLevelPath } from "lib/getTopLevelPath"
import { MissingComparisonDocument } from "routes/schedule/compare/missing-comparison-document"
import { ComparisonLoadFailed } from "routes/schedule/compare/comparison-load-failed"

export function ComparisonView({ destination, source, other = [], retry }) {
    const { themeStretch } = useSettings()
    const [title] = useSearchParam("title")
    const currentApp = getTopLevelPath()

    // schedule -> null resolve branch
    const missing = getMissingDocument()
    if (missing) return <MissingComparisonDocument missing={missing} />

    // error resolve branch
    const failed = getFailedDocument()
    if (failed && retry) return <ComparisonLoadFailed failed={failed} retry={retry} />
    if (failed) {
        return (
            <Alert severity="warning">
                <Typography variant="subtitle1" gutterBottom>
                    No longer available
                </Typography>
                <Typography variant="body1">The view is no longer available.</Typography>
            </Alert>
        )
    }
    const [{ _id } = {}, , , name] = destination
    const [, , , otherVersionName] = other
    const [, , , comparison] = source

    return (
        <Page title={`Compare ${name} to ${otherVersionName ?? comparison}`}>
            <Container maxWidth={themeStretch ? false : "xl"}>
                {!!title && (
                    <Container>
                        <Typography variant="h6">{title}</Typography>
                    </Container>
                )}
                <UpBar id={splitId(_id).id} />
                <Box className={`schedule-details styled-bullets ${currentApp}`}>
                    <CompareTwo destination={destination} source={source} other={other} />
                </Box>
                <Box mb={50} />
            </Container>
        </Page>
    )

    function getMissingDocument() {
        if (destination === null) return "destination"
        if (source === null) return "source"
        if (other === null) return "other"
        return null
    }

    function getFailedDocument() {
        if (destination instanceof Error) return "destination"
        if (source instanceof Error) return "source"
        if (other instanceof Error) return "other"
        return null
    }
}
